import ChatColumn from "./ChatColumn";

export type ColumnRef = {
  project: string;
  conversationId: number;
  branch: string | null;
  /**
   * Pinned worktree path, forwarded from whatever row the column was opened
   * from. Optional because it is NULL on every conversation that has never
   * been renamed, and the header renders nothing for it rather than guessing.
   */
  worktreeDir?: string | null;
};

type Props = {
  columns: ColumnRef[];
  focusedIndex: number;
  /** Display name for a registry id; absent => columns show the id. */
  projectName?: (id: string) => string;
  onFocus: (index: number) => void;
  onClose: (index: number) => void;
  /** Open a conversation (by id) as a focused new column — used by Issues takeover. */
  onOpenConversation?: (conversationId: number, branch: string | null, worktreeDir?: string | null) => void;
};

export default function ColumnLayout({ columns, focusedIndex, projectName, onFocus, onClose, onOpenConversation }: Props) {
  if (columns.length === 0) {
    return <div className="chat-empty">Select a conversation, or start a new one.</div>;
  }
  return (
    <div className="column-layout">
      {columns.map((c, i) => (
        <ChatColumn
          key={`${c.project}:${c.conversationId}`}
          project={c.project}
          projectName={projectName?.(c.project)}
          conversationId={c.conversationId}
          branch={c.branch}
          worktreeDir={c.worktreeDir}
          focused={i === focusedIndex}
          onFocus={() => onFocus(i)}
          onClose={() => onClose(i)}
          onOpenConversation={onOpenConversation}
        />
      ))}
    </div>
  );
}
